import React, { Component } from 'react';
import { isEmpty, isNil } from 'ramda';
import { Helmet } from 'react-helmet';

import AdministrationPage from '../containers/AdministrationPage';
import SecondHandBoardgameForm from './SecondHandBoardgameForm';
import Error from './Error';

import placeIcon from '../assets/images/icon-plane.svg';

class AdminSecondHandBoardgamePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.params.id,
      isEditMode: !isNil(props.params.id) && !isEmpty(props.params.id),
      requested: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (this.state.isEditMode && !this.props.boardgame && !this.state.requested) {
      this.props.getBoardgame(this.props.params.id);
      this.setState({ requested: true });
    }
  }

  handleSubmit(values) {
    const bg = Object.assign({}, values, this.state.isEditMode ? {} : {
      sold: false,
      soldAt: null,
      createdAt: new Date(),
      updatedAt: new Date(),
    });

    if (this.state.isEditMode) {
      this.props.updateBoardgame(this.state.id, bg);
    } else {
      this.props.createBoardgame(bg);
    }
  }


  render() {
    if (this.state.isEditMode && this.state.requested && !this.props.loading && !this.props.boardgame) {
      return <Error
        title="Non abbiamo trovato il gioco che hai chiesto..."
        message="Forse ti sei perso mentre sfogliavi i regolamenti dei tuoi nuovi giochi."
        icon={placeIcon} />
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>
            { this.state.isEditMode ? ((this.props.boardgame && this.props.boardgame.title) || 'Caricamento...') : 'Nuovo titolo Replay' } - Smart Gaming
          </title>
        </Helmet>
        <AdministrationPage>
          <SecondHandBoardgameForm
            loading={this.props.loading}
            editMode={this.state.isEditMode}
            title={this.state.isEditMode ? 'Modifica titolo' : 'Nuovo titolo'}
            initialValues={this.state.isEditMode ? this.props.boardgame : {}}
            categories={this.props.categories}
            onSubmit={this.handleSubmit} />
        </AdministrationPage>
      </React.Fragment>
    );
  }
}

export default AdminSecondHandBoardgamePage;
